import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import IconCircleChecked from '~~elements/static/IconCircleChecked.svg';
import IconBlock from '~~elements/static/IconBlock.svg';
import IconAttachment from '~~elements/static/IconAttachment.svg';
import { TABLET_WIDTH, PHONE_WIDTH } from '~~elements/Const';
import RMultilingual from '../Multilingual';
import { useRegistryState } from '../useRegistry';
import { getLinkPrivacy } from '../service';
import { currencyDisplay } from '../../Const';
import moment from 'moment';

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  label {
    margin: 0 1rem;
  }

  h4 {
    white-space: nowrap;
  }

  .article {
    white-space: pre-line;
    text-align: left;
    line-height: 2rem;
    letter-spacing: 2px;
  }

  .basic-info {
    display: grid;
    grid-template-columns: 1fr 3fr;
    > * {
      margin: 0;
      padding: 1rem 0.5rem;
      &.row-group {
        padding: 0.5rem 0.5rem;
      }
      &.row-gap {
        margin-bottom: 1rem;
      }
    }
    padding-bottom: 0.5rem;
    border-bottom: 1px solid gray;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    .basic-info {
      width: 100%;
      grid-template-columns: 10rem 1fr;
      > * {
        padding: 0.8rem 0.3rem 0.8rem 0;
        &.row-group {
          padding: 0.4rem 0.3rem 0.4rem 0;
        }
        &.row-gap {
          margin-bottom: 0.8rem;
        }
      }
    }

    .article {
      line-height: 2.2rem;
      text-indent: 1.2rem;
    }
  }

  @media (max-width: ${PHONE_WIDTH}) {
    font-size: 0.9rem;
    .basic-info {
      grid-template-columns: 100%;
    }
  }
`;

const OverviewSection = () => {
  const { registryInfo, teamsInReview } = useRegistryState();

  const [startAt, setStartAt] = useState(null);
  const [endAt, setEndAt] = useState(null);
  const [openRegistration, setOpenRegistration] = useState(false);

  const [linkPrivacy, setLinkPrivacy] = useState('PUBLIC');

  useEffect(() => {
    const newStartAt = new Date(registryInfo.start_at);
    const newEndAt = new Date(registryInfo.end_at);
    setStartAt(newStartAt);
    setEndAt(newEndAt);
    if (!moment(newStartAt).isValid() || !moment(newEndAt).isValid()) {
      setOpenRegistration(false);
      return;
    }

    setOpenRegistration(moment().isSameOrAfter(newStartAt) && moment().isSameOrBefore(newEndAt));
  }, [registryInfo.end_at, registryInfo.start_at]);

  useEffect(() => {
    setLinkPrivacy(getLinkPrivacy(registryInfo.is_public, registryInfo.entry_key));
  }, [registryInfo.entry_key, registryInfo.is_public]);

  const getFee = () => {
    if (registryInfo.fee === 0) {
      return RMultilingual(`FEE.FREE`);
    }

    const currency = currencyDisplay[registryInfo.fee_currency];
    return `${currency.text} ${registryInfo.fee.toFixed(currency.toFixed)}`;
  };

  return (
    <StyledDiv>
      <div className="basic-info">
        <h4>{RMultilingual(`DATE_RANGE`)}</h4>
        <label>
          {
            <img
              style={{ width: '1.5rem', height: '1.5rem' }}
              src={openRegistration ? IconCircleChecked : IconBlock}
              alt="whetherOpen"
            />
          }
          {moment(startAt).isValid() &&
            moment(endAt).isValid() &&
            `${moment(startAt).format('YYYY/MM/DD HH:mm')} - ${moment(endAt).format('YYYY/MM/DD HH:mm')}`}
        </label>
        <h4 className="row-gap">
          {RMultilingual(`LINK`)}({RMultilingual(`LINK_PRIVACY.${linkPrivacy}`)})
        </h4>
        <label className="row-gap">
          <a
            href={`${process.env.REACT_APP_MAINPAGE_URL}/registry/${registryInfo.uniqid}`}
            target="_blank"
            rel="noopener noreferrer"
          >{`${process.env.REACT_APP_MAINPAGE_URL}/registry/${registryInfo.uniqid}`}</a>
        </label>
        {/* <h4 className="row-group">{RMultilingual(`TEAM_STATUS.WORDING`)}</h4>
        <label className="row-group" />
        <h4 className="row-group">{RMultilingual(`TEAM_STATUS.REVIEW_REQUESTED`)}</h4>
        <label className="row-group">{filter((t) => t.status === 'REVIEW_REQUESTED', teamsInReview).length}</label>
        <h4 className="row-group">{RMultilingual(`TEAM_STATUS.REVIEW_COMPLETED`)}</h4>
        <label className="row-group">{filter((t) => t.status === 'REVIEW_COMPLETED', teamsInReview).length}</label>
        <h4 className="row-group">{RMultilingual(`TEAM_STATUS.PAYMENT_CHECK_REQUESTED`)}</h4>
        <label className="row-group">
          {filter((t) => t.status === 'PAYMENT_CHECK_REQUESTED', teamsInReview).length}
        </label>
        <h4 className="row-group row-gap">{RMultilingual(`TEAM_STATUS.COMPLETED`)}</h4>
        <label className="row-group row-gap">
          {filter((t) => t.status === 'COMPLETED', teamsInReview).length}/{registryInfo.team_limit}
        </label> */}
        <h4>{RMultilingual(`FEE.WORDING`)}</h4>
        <label>{getFee()}</label>
      </div>
      <h3>{RMultilingual(`DESCRIPTION`)}</h3>
      <div className="article">{registryInfo.description}</div>
      <h3>{RMultilingual(`CONTENT`)}</h3>
      <label>
        <img src={IconAttachment} style={{ width: '1rem', height: '1rem' }} alt="attachIcon" />
        {!registryInfo.regulation_file_url ? (
          RMultilingual(`DOCUMENT.NONE`)
        ) : (
          <a href={registryInfo.regulation_file_url} target="_blank" rel="noopener noreferrer">
            {registryInfo.regulation_file_url}
          </a>
        )}
      </label>
      <h3>{RMultilingual(`DOCUMENT.WORDING`)}</h3>
      {registryInfo.attachments.length === 0 ? (
        <label>{RMultilingual(`DOCUMENT.NONE`)}</label>
      ) : (
        registryInfo.attachments.map((attachment) => (
          <label key={attachment.path}>
            <img src={IconAttachment} style={{ width: '1rem', height: '1rem' }} alt="attachIcon" />
            <a href={attachment.url} target="_blank" rel="noopener noreferrer">
              {attachment.url}
            </a>
          </label>
        ))
      )}
    </StyledDiv>
  );
};

export default OverviewSection;
